import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { isSignedInSelector } from "ccui-framework";

import passAssist from "../pages/passAssist.jsx";
import ContactUsPage from "../pages/ContactUsPage.jsx";
import NotFound from "../components/static/404.jsx";
import Orders from "../pages/orders.jsx";
import Payments from "../pages/payments.jsx";
import CardsPage from "../pages/CardsPage.jsx";
import LiabilitiesPage from "../pages/LiabilitiesPage.jsx";
import PrivacyPolicy from "../pages/privacyPolicy.jsx";
import EmailSentPassReset from "../components/passReset/emailSent.jsx";
import EmailSent from "../components/static/emailSent.jsx";
import CheckPassToken from "../pages/checkPassToken.jsx";
import ConfirmationResetPass from "../components/passReset/confirmation.jsx";
import ReceiptPage from "../pages/ReceiptPage.jsx";
import CurrentRates from "../pages/currentRates.jsx";
import SpreadsheetInstructions from "../pages/spreadsheetInstructions.jsx";
import SignUp from "../pages/signUp.jsx";
import SignUpConfirmation from "../components/bulk/signUpConfirmation.jsx";

import { Switch } from "react-router-dom";
import { PublicRoute, PrivateRoute } from "ccui-framework";
import CustomerSigninPage from "../pages/CustomerSigninPage";
import FAQPage from "../pages/FaqPage.jsx";
import PaymentMethodsPage from "../pages/PaymentMethodsPage";
import CreateOrderPage from "../pages/CreateOrderPage";

const SignInOrRedirect = () => {
  const isSignedIn = useSelector(isSignedInSelector);
  return isSignedIn ? <Redirect to="/current-rates" /> : <CustomerSigninPage />;
};

export default {
  Main: () => (
    <Switch>
      <Route exact path="/" component={SignInOrRedirect} />
      <Route path="/login" component={SignInOrRedirect} />
      <Route path="/security/login" component={SignInOrRedirect} />
      <PublicRoute path="/sign-up" component={SignUp} />
      <PublicRoute path="/pass-assist" component={passAssist} />
      <PublicRoute path="/email-sent" component={EmailSent} />
      <PublicRoute
        path="/email-sent-pass-reset"
        component={EmailSentPassReset}
      />
      <PublicRoute
        path="/sign-up-confirmation"
        component={SignUpConfirmation}
      />
      <PublicRoute path="/forgot-password/:token" component={CheckPassToken} />
      <PublicRoute
        path="/confirm-reset-pass"
        component={ConfirmationResetPass}
      />
      <PublicRoute path="/privacy-policy" component={PrivacyPolicy} />

      <PrivateRoute
        path="/spreadsheet-instructions"
        component={SpreadsheetInstructions}
      />
      <PrivateRoute
        path="/account/payment-methods"
        component={PaymentMethodsPage}
      />
      <PrivateRoute path="/faq" component={FAQPage} />
      <PrivateRoute path="/contact" component={ContactUsPage} />
      <PrivateRoute path="/current-rates" component={CurrentRates} />
      <PrivateRoute path="/order-complete" component={ReceiptPage} />
      <PrivateRoute path="/new-order/enter-cards" component={CreateOrderPage} />
      <PrivateRoute path="/account/orders" component={Orders} />
      <PrivateRoute path="/account/orders/:id" component={Orders} />
      <PrivateRoute path="/account/payments" component={Payments} />
      <PrivateRoute path="/account/cards" component={CardsPage} />
      <PrivateRoute path="/account/liabilities" component={LiabilitiesPage} />

      <PublicRoute path="*" component={NotFound} />
    </Switch>
  ),
};
